import * as nodeUtils from "./nodeUtils";
import * as pathUtils from "./pathUtils";
import * as nodeSelector from "../nodeSelector";

export const validateSingleFunction = (root, name) => {
  const functions = nodeUtils.getFunctions(root);

  if (functions.length !== 1) {
    return { res: false, msg: "There should be exactly one function in the model." };
  }

  if (name) {
    if (nodeUtils.getName(functions[0]) !== name) {
      return { res: false, msg: `The function should be named ${name}.` };
    }
  }

  return { res: true, msg: "OK" };
};

export const validateParametersLinked = (root, parent, names) => {
  const ref = nodeUtils.getParameters(root).filter((e) => nodeUtils.getName(e) === parent);

  if (!ref) {
    throw new Error("The global parameter is non-existent");
  }

  const idRef = nodeUtils.getID(ref[0]);

  const funcs = nodeUtils.getFunctions(root);
  const paramsLinked = nodeUtils
    .getParameters(funcs[0])
    .filter((e) => nodeUtils.isParameterLinked(e));

  const missingElements = [];

  for (let i = 0; i < names.length; i++) {
    let found = false;

    for (let j = 0; j < paramsLinked.length; j++) {
      if (names[i] === nodeUtils.getName(paramsLinked[j])) {
        found = true;
        if (nodeUtils.getIdTarget(paramsLinked[j]) !== idRef) {
          return {
            res: false,
            msg: `The reference of linked parameter '${nodeUtils.getName(paramsLinked[j])}' is erroneous - '${nodeUtils.getIdTarget(paramsLinked[j])}'.`,
          };
        }
      }
    }

    if (!found) {
      missingElements.push(names[i]);
    }
  }

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following linked parameters are missing: ${missingElements.join(", ")}.`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateParametersOutput = (root, names) => {
  const parent = nodeUtils.getFunctions(root)[0];

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const elements = nodeUtils
    .getParameters(parent)
    .filter((e) => nodeUtils.getValueDefault(e))
    .map((e) => nodeUtils.getName(e));

  const missingElements = [];

  names.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following output parameters are missing: ${missingElements.join(", ")}`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateChoices = (root, parentId, choices) => {
  const parent = nodeSelector.getNodeById(root, parentId)?.data;

  if (!parent) {
    throw new Error("The parent is non-existent");
  }

  const elements = nodeUtils.getChoices(parent).map((e) => nodeUtils.getName(e));

  const missingElements = [];

  choices.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following choices are missing: ${missingElements.join(", ")}`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateParameters = (root, parentId, parameters) => {
  const parent = nodeSelector.getNodeById(root, parentId)?.data;

  if (!parent) {
    const name = pathUtils.getName(parentId);
    return { res: false, msg: `The parameters is missing: ${name}.`}
  }

  const elements = nodeUtils.getParameters(parent).map((e) => nodeUtils.getName(e));

  const missingElements = [];

  parameters.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following parameters are missing: ${missingElements.join(", ")}.`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateOutput = (root, id, value) => {
  const node = nodeSelector.getNodeById(root, id)?.data;

  if (!node) {
    const name = pathUtils.getName(id);
    return { res: false, msg: `The output parameter is missing: ${name}.`}
  }

  const output = nodeUtils.getValueDefault(node);

  if (value !== output) {
    return {
      res: false,
      msg: `The output is incorrect: ${output}.`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateValue = (root, id, value) => {
  const node = nodeSelector.getNodeById(root, id)?.data;

  if (!node) {
    const name = pathUtils.getName(id);
    return { res: false, msg: `The node is missing: ${name}.`}
  }

  const output = nodeUtils.getValue(node);

  if (value !== output) {
    return {
      res: false,
      msg: `The value is incorrect: ${output}.`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateCondition = (root, id, expression) => {
  const node = nodeSelector.getNodeById(root, id)?.data;

  if (!node) {
    const name = pathUtils.getName(id);
    return { res: false, msg: `The condition is missing: ${name}.`}
  }

  const output = nodeUtils.getExpression(node);

  if (expression !== output) {
    return {
      res: false,
      msg: `The expression is incorrect: ${nodeUtils.getName(output)}.`,
    };
  }

  return { res: true, msg: "OK" };
};

export const validateLabels = (root, id, labels) => {
    const node = nodeSelector.getNodeById(root, id)?.data;

  if (!node) {
    const name = pathUtils.getName(id);
    return { res: false, msg: `The element is missing: ${name}.`}
  }

  const elements = nodeUtils.getLabel(node);

  const missingElements = [];

  labels.forEach((name) => {
    if (!elements.includes(name)) {
      missingElements.push(name);
    }
  });

  if (missingElements.length > 0) {
    return {
      res: false,
      msg: `The following labels are missing: ${missingElements.join(", ")}`,
    };
  }

  return { res: true, msg: "OK" };
};